<template>
    <div
        class="bodybox"
        id="jiaoanx"
        style="padding:0.2rem"
        oncontextmenu="return false"
        onselectstart="return false"
        ondragstart="return false"
    >
        <div id="app" style="padding:8px 15px 0">
            <input type="hidden" id="reid" :value="re_id" />
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-4" style="padding: 0;height: 100%;">
                        <div class="fix">
                            <div class="btn-group" style="width: 32%;float: left">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang1"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >课程系列</button>
                            </div>
                            <div class="btn-group" style="width: 32%;;margin-left: 2%;float: left">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang1"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >全部课程</button>
                            </div>
                            <div class="btn-group" style="width: 32%;float: right">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang2"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >
                                    <span>{{kecheng2}}</span>
                                </button>
                            </div>
                        </div>
                        <div class="fix">
                            <div style="width: 32%;float: left" v-if="quanke3">
                                <div
                                    class="kelist hang1"
                                    v-for="ke in quanke3"
                                    :class="{active1:(ke.classa==classname)}"
                                    @click="ke3(ke.classa)"
                                    :key="ke.classa"
                                    v-cloak
                                >{{ke.classa}}</div>
                            </div>
                            <div style="width: 32%;float: left;margin-left: 2%" v-if="quanke1">
                                <div
                                    class="kelist hang1"
                                    v-for="ke in quanke1"
                                    :class="{active1:(ke.kc_id==kcid)}"
                                    @click="ke1(ke.kc_id)"
                                    :key="ke.kc_id"
                                    v-cloak
                                >{{ke.title}}</div>
                            </div>
                            <div style="width: 32%;float: right;margin-left: 2%" v-if="quanke2">
                                <div
                                    class="kelist hang1"
                                    v-for="ke in quanke2"
                                    :class="{active2:(ke.id==iid)}"
                                    @click="ke2(ke.id)"
                                    :key="ke.id"
                                    v-cloak
                                >{{ke.title}}</div>
                            </div>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                    <div class="col-sm-8">
                        <div>
                            <div
                                class="conTitle text-center"
                                style="height: 85px;line-height: 85px;border-radius: 10px;background: #fff;"
                            >
                                <span v-cloak style="font-size: 24px">{{title}}</span>
                                <span style="color: #999;font-size: 12px">
                                    (
                                    <span v-cloak>{{kechengname}}</span>)
                                </span>
                            </div>
                            <div class="container-fluid">
                                <div class="row">
                                    <div
                                        class="col-sm-6"
                                        style="padding: 0;padding-right:4px;margin-bottom: 4px "
                                    >
                                        <div class="fix titleListBox">
                                            <div class="titleList" style="cursor: auto">
                                                <span>开场舞</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="yin1($event)"
                                                v-if="audios"
                                                :aud="audios"
                                                style="color: #999;float: right"
                                            >
                                                <!--<span style="font-size:22px;vertical-align: middle;" class="fa fa-music"></span>-->
                                                <img
                                                    src="/static/qmsj/img/music.png"
                                                    style="width: 22px;margin-right: 3px;"
                                                />
                                                <span style="padding-left:1px ">音乐播放</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="ship1($event)"
                                                v-if="ships"
                                                v-bind:ship="ships"
                                                style="color: #999;float: right"
                                            >
                                                <span
                                                    style="font-size:22px;vertical-align: middle;"
                                                    class="fa fa-play-circle"
                                                ></span>
                                                <span style="padding-left:6px ">视频演示</span>
                                            </div>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>
                                    <div
                                        class="col-sm-6"
                                        style="padding: 0;padding-left: 4px;margin-bottom: 4px"
                                    >
                                        <div class="fix titleListBox">
                                            <div class="titleList" style="cursor: auto">
                                                <span>再见仪式</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="yin1($event)"
                                                v-if="audioe"
                                                v-bind:aud="audioe"
                                                style="color: #999;float: right"
                                            >
                                                <img
                                                    src="/static/qmsj/img/music.png"
                                                    style="width: 22px;margin-right: 3px;"
                                                />
                                                <span style="padding-left:6px ">音乐播放</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="ship1($event)"
                                                v-if="shipe"
                                                v-bind:ship="shipe"
                                                style="color: #999;float: right"
                                            >
                                                <span
                                                    style="font-size:22px;vertical-align: middle;"
                                                    class="fa fa-play-circle"
                                                ></span>
                                                <span style="padding-left:6px ">视频演示</span>
                                            </div>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>

                                    <div class="col-sm-12" style="padding: 0">
                                        <div class="neirong" style="padding: 0;">
                                            <!--<div v-html='zhengwen'>-->
                                            <!--</div>-->
                                            <div class="zhengwen" v-for="(fen,index) in fendata">
                                                <div class="fix">
                                                    <p class="title11" style="float: left;">
                                                        {{index+1}}
                                                        <span>.</span>
                                                        {{fen.title}}
                                                    </p>

                                                    <div
                                                        class="titleList"
                                                        v-on:click="yin1($event)"
                                                        v-if="fen.process_audio_vid"
                                                        v-bind:aud="fen.process_audio_vid"
                                                        style="float: right;color: #999"
                                                    >
                                                        <img
                                                            src="/static/qmsj/img/music.png"
                                                            style="width: 22px;margin-right: 3px;"
                                                        />
                                                        <span>音乐播放</span>
                                                    </div>
                                                    <div style="clear: both;"></div>

                                                    <div
                                                        class="titleList"
                                                        v-on:click="ship1($event)"
                                                        v-if="fen.process_video"
                                                        v-bind:ship="fen.process_video"
                                                        style="float: right;color: #999"
                                                    >
                                                        <span
                                                            style="font-size:22px;vertical-align: middle;"
                                                            class="fa fa-play-circle"
                                                        ></span>
                                                        <span style="padding-left:6px ">视频演示</span>
                                                    </div>
                                                </div>
                                                <div class="neirong11" v-html="fen.process"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12" style="padding: 0">
                                        <div style="padding: 10px 0 20px">
                                            <i style="color:#fdb06a ">
                                                <span class="fa fa-eye"></span>
                                                <span>
                                                    浏览次数
                                                    <span>{{ydrs}}</span> 次
                                                </span>
                                            </i>
                                            <i style="color:#79c4c7">
                                                <span
                                                    class="fa fa-star-o"
                                                    style="padding-left:28px "
                                                ></span>
                                                <span>
                                                    收藏
                                                    <span>{{shouc}}</span>次
                                                </span>
                                            </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="myModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            style="background:rgba(0,0,0,0.3) "
        >
            <div class="modal-dialog" role="document" style="width:850px;margin:5% auto;">
                <div class="modal-content">
                    <div class="modal-body" style="padding: 5px;">
                        <div
                            aria-hidden="true"
                            v-on:click="guans"
                            style="float: right;cursor: pointer;font-size:28px;"
                        >&times;</div>
                        <div style="clear: both;"></div>
                        <div style="margin-top: 0;">
                            <div id="myVideo"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="myModa2"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            style="background:rgba(0,0,0,0.3) "
        >
            <div class="modal-dialog" role="document" style="width:600px;margin: 15% auto;">
                <div class="modal-content">
                    <div class="modal-body" style="padding:10px;" id="yinp">
                        <div
                            aria-hidden="true"
                            v-on:click="guans2"
                            style="float: right;cursor: pointer;font-size:25px;"
                        >&times;</div>
                        <div style="clear: both;"></div>
                        <div style="margin-top: 0;">
                            <div id="myaudio"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            kechengname: "",
            iid: "",
            kcid: "",
            quanke1: "",
            quanke2: "",
            is_sc: 0,
            is_bk: 0,
            kecheng2: "全部课程",
            ydrs: "",
            shouc: "",
            zhengwen: "",
            re_id: "",
            shipp: "",
            ships: "",
            shipe: "",
            audios: "",
            audioe: "",
            fendata: "",
            audio: "",
            play_auth: "",
            player: "",
            player0: "",
            jiaoid: "",
            quanke3: "",
            tokenc: "",
            classname: ""
        };
    },
    methods: {
        jump: function(d) {
            this.$router.push(d);
        },
        ke1: function(i) {
            var self = this;
            self.kcid = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoangym/qbja",
                type: "post",
                dataType: "json",
                data: {
                    kc_id: i,
                    token: self.tokenc
                },
                success: function(data) {
                    self.quanke2 = data.data;
                }
            });
        },
        ke2: function(i) {
            var self = this;
            self.iid = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoangym/deta",
                type: "post",
                dataType: "json",
                data: {
                    id: self.iid,
                    token: self.tokenc
                },
                success: function(data) {
                    self.iid = data.data.zong.id;
                    self.title = data.data.zong.title;
                    self.kechengname = data.data.zong.kc_name;
                    self.is_sc = data.data.zong.is_sc;
                    self.is_bk = data.data.zong.is_bk;
                    self.ydrs = data.data.zong.ydrs;
                    self.shouc = data.data.zong.sc;
                    self.zhengwen = data.data.zong.process;
                    self.re_id = data.data.zong.re_id;
                    self.audios = data.data.zong.start_vid;
                    self.audioe = data.data.zong.end_vid;
                    self.ships = data.data.zong.start_video;
                    self.shipe = data.data.zong.end_video;
                    self.fendata = data.data.fen;
                }
            });
        },
        ke3: function(i) {
            var self = this;
            self.classname = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoangym/get_gym_titles",
                type: "post",
                dataType: "json",
                data: {
                    classname: i,
                    token: self.tokenc
                },
                success: function(data) {
                    self.quanke1 = data.data;
                }
            });
        },
        // 音乐
        yin1: function(ev) {
            var self = this;
            var el = ev.currentTarget;
            self.audio = $(el).attr("aud");

            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/getplayauth",
                type: "post",
                dataType: "json",
                data: {
                    vid: self.audio,
                    token: self.tokenc
                },
                success: function(data) {
                    self.play_auth = data.play_auth;
                    $("#myModa2").modal({
                        backdrop: "static"
                    });
                    if (self.player0) {
                        self.player0.dispose();
                    }

                    $("#myaudio").empty();
                    setTimeout(function() {
                        self.player0 = Aliplayer({
                            id: "myaudio",
                            autoplay: true,
                            width: "580px",
                            height: "100px",
                            vid: self.audio,
                            playauth: self.play_auth,
                            mediaType: "audio",
                            controlBarVisibility: "always"
                        });
                    }, 10);
                }
            });
        },
        // 视频
        ship1: function(ev) {
            var self = this;
            var el = ev.currentTarget;
            self.shipp = $(el).attr("ship");
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/getplayauth",
                type: "post",
                dataType: "json",
                data: {
                    vid: self.shipp,
                    token: self.tokenc
                },
                success: function(data) {
                    self.play_auth = data.play_auth;
                    $("#myModal").modal({
                        backdrop: "static"
                    });

                    if (self.player) {
                        self.player.dispose();
                    }
                    $("#myVideo").empty();
                    setTimeout(function() {
                        self.player = Aliplayer({
                            id: "myVideo",
                            autoplay: true,
                            width: "817px",
                            height: "460px",
                            vid: self.shipp,
                            playauth: self.play_auth
                        });
                    }, 10);
                }
            });
        },

        guans: function() {
            if (self.player) {
                self.player.dispose();
            }

            $("#myVideo").empty();
            $("#myModal").modal("hide");
        },
        guans2: function() {
            if (self.player0) {
                self.player0.dispose();
            }
            $("#myaudio").empty();
            $("#myModa2").modal("hide");
        },
        get_one() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoangym/get_gym_classes",
                    type: "post",
                    dataType: "json",
                    data: {
                        token: self.tokenc
                    },
                    success: function(data) {
                        self.classname = data.data[0].classa;
                        self.quanke3 = data.data;
                        resolve();
                    },
                    complete: function() {}
                });
            });
        },
        get_two() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoangym/get_gym_titles",
                    type: "post",
                    dataType: "json",
                    data: {
                        classname: self.classname,
                        token: self.tokenc
                    },
                    success: function(data1) {
                        self.kcid = data1.data[0].kc_id;
                        self.quanke1 = data1.data;
                        resolve();
                    },
                    complete: function() {}
                });
            });
        },
        get_three() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoangym/qbja",
                    type: "post",
                    dataType: "json",
                    data: {
                        kc_id: self.kcid,
                        token: self.tokenc
                    },
                    success: function(data2) {
                        self.jiaoid = data2.data[0].id;
                        self.quanke2 = data2.data;
                        resolve();
                    },
                    complete: function() {}
                });
            });
        },
        get_four() {
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoangym/deta",
                type: "post",
                dataType: "json",
                data: {
                    id: self.jiaoid,
                    token: self.tokenc
                },
                success: function(data3) {
                    self.kcid = data3.data.zong.kc_id;
                    self.iid = data3.data.zong.id;
                    self.title = data3.data.zong.title;
                    self.kechengname = data3.data.zong.kc_name;
                    self.is_sc = data3.data.zong.is_sc;
                    self.is_bk = data3.data.zong.is_bk;
                    self.ydrs = data3.data.zong.ydrs;
                    self.shouc = data3.data.zong.sc;
                    self.zhengwen = data3.data.zong.process;
                    self.re_id = data3.data.zong.re_id;
                    self.ships = data3.data.zong.start_video;
                    self.shipe = data3.data.zong.end_video;
                    self.audios = data3.data.zong.start_vid;
                    self.audioe = data3.data.zong.end_vid;
                    self.fendata = data3.data.fen;
                }
            });
        },
        async get_request() {
            await this.get_one();
            await this.get_two();
            await this.get_three();
            this.get_four();
        }
    },
    created: function() {
        let self = this;
        self.tokenc = self.$cookies.get("token");

        self.get_request();
    }
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

* {
    margin: 0;
    padding: 0;
    font-size: 14px;
    /*font-family: "微软雅黑";*/
}

.fl {
    float: left;
}

.hang1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hang2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.hang3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

p,
label {
    margin: 0;
    padding: 0;
}

body {
    background: #ededed;
}

.btna {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}

.kezhuang1 {
    background: #00cce4;
    color: #fff;
}

body .dropdown-menu > li > a {
    line-height: 28px;
}

.kezhuang2 {
    background: #ff797c;
    color: #fff;
}

.dropm1,
.dropm2 {
    width: 100%;
    padding: 0;
}

.dropm1 {
    border: 1px solid #fdb06a;
    border-radius: 0 0 5px 5px;
}

.dropm2 {
    border: 1px solid #79c4c7;
    border-radius: 0 0 5px 5px;
}

.dropm1 li {
    border-bottom: 1px solid #fdb06a;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.dropm2 li {
    border-bottom: 1px solid #79c4c7;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.dropdown-menu > li > a {
    padding: 5px 20px;
}

.kelist {
    cursor: pointer;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
    color: #999;
    margin-bottom: 3px;
}

.kelist.active1 {
    color: #00cce4;
    box-shadow: 0 3px 10px #8ae3ed;
}

.kelist.active2 {
    color: #ff797c;
    box-shadow: 0 3px 10px #e9afb0;
}

.conTitle {
    font-size: 20px;
    margin-bottom: 4px;
}

.zidBtn {
    height: 30px;
    width: 104px;
    text-align: center;
    line-height: 30px;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    border: none;
    margin: 30px 20px 0 0;
    cursor: pointer;
}

.zidg {
    background: #ff797c;
}

.zidy {
    background: #00cce4;
}

.titleListBox {
    /*border-bottom: 2px solid #fff;*/
    /*border-right: 2px solid #fff;*/
    border-radius: 10px;
    background: #fff;
}

.titleList {
    float: left;
    /*width: 40%;*/

    height: 50px;
    line-height: 50px;
    padding-left: 22px;
    cursor: pointer;
}

#myVideo {
    margin: auto;
}

/*上下的按钮*/
.neirong::-webkit-scrollbar {
    display: none;
}

/*导航条样式宽度*/
.neirong::-webkit-scrollbar-button {
    display: none;
}

/*上下的按钮*/

.neirong::-webkit-scrollbar-track {
    /*background:#FF66D5;*/
    display: none;
}

/*导航条样式颜色*/

.neirong::-webkit-scrollbar-thumb {
    display: none;
}

/*滚动条样式颜色*/
.neirong::-webkit-scrollbar-corner {
    display: none;
}

.zhengwen {
    background: #fff;
    border-radius: 10px;
    padding-left: 10px;
    margin-bottom: 4px;
}

.title11 {
    line-height: 50px;
    font-size: 18px;
}

.neirong11 {
    padding-left: 35px;
    padding-bottom: 10px;
}

.neirong {
    overflow-y: scroll;
    background: #eee;
    padding: 20px;
}

.tuiBtn {
    width: 190px;
    height: 40px;
    text-align: center;
    font-size: 20px;
    line-height: 40px;
    border-radius: 20px;
    background: #7c72c1;
    color: #fff;
    margin: 0 auto;
    cursor: pointer;
    box-shadow: 0 3px 10px #a4a3aa;
}

.backp {
    background: #e8e5ff;
    color: #000;
}

/* 判断ipad */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    /* style */
    #yinp {
        height: 120px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/jiaoan/jiaoan4.vue